'use client'

/* eslint-disable react/no-unescaped-entities */

import {
  useResponsive,
  useTranslations,
  useUserSettings,
} from '@dustin-web/microsite-components/src/hooks'
import React from 'react'
import { usePathname } from 'next/navigation'

export const NorwegianRewards = () => {
  const { translate } = useTranslations()
  const pathname = usePathname()
  const { isSmallScreen } = useResponsive()
  const { selectedContactId } = useUserSettings()
  const rewardNumberIsValid = false
  // var encodedReturnUrl = Url.Encode(string.Format("{0}?rewardno=[REWARD_NO]", Request.Url.GetLeftPart(UriPartial.Path)));
  // var norwegianUrl = string.Format("https://{0}.norwegianreward.com/login?returnUrl={1}", SiteSettings.SourcingCompany.ToString(), encodedReturnUrl);
  const norwegianUrl = ''

  return (
    <div className="container affiliate">
      {selectedContactId ? (
        rewardNumberIsValid ? (
          'Valid'
        ) : (
          <div className="row">
            <div className="col-12 col-sm-10 col-md-7 margin-top-md">
              <a
                href={norwegianUrl}
                className="btn btn-primary btn-lg margin-y-md text-center"
                style={{ width: '100%;' }}>
                {translate('NorwegianRewards_FetchRewardNumber')}
              </a>
            </div>
          </div>
        )
      ) : (
        <>
          <div className="row">
            <div className="col-12 margin-top-md">
              <h2>{translate('NorwegianRewards_LogInToActivate')}</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-12 col-sm-6 col-md-4">
              <h3>{translate('NorwegianRewards_ExistingCustomer')}</h3>
              <div className="form-group" style={{ overflowY: 'auto' }}></div>
              <a href={`/login?returnUrl=${pathname}`} className="btn btn-primary">
                {translate('Login')}
              </a>
            </div>
            <div className="col-12 col-sm-6 col-md-4">
              <h3>{translate('NorwegianRewards_NewCustomer')}</h3>
              <div className="form-group" style={{ overflowY: 'auto' }}></div>
              {isSmallScreen ? (
                <a
                  href={`/registration?returnUrl=${pathname}`}
                  className="padding-x-lg btn btn-primary">
                  {translate('NorwegianRewards_Register')}
                </a>
              ) : (
                <a
                  href={`/registration?returnUrl=${pathname}`}
                  className="padding-x-lg btn btn-primary">
                  {translate('NorwegianRewards_Register')}
                </a>
              )}
            </div>
            <div className="col-12 col-md-4">
              <div className="visible-xs visible-sm">
                <hr />
              </div>
              <div className="affiliateInfoBox">
                <h3>{translate('NorwegianRewards_WhyAccountHeading')}</h3>
                <ul>
                  <li className="h4">{translate('NorwegianRewards_WhyAccount1')}</li>
                  <li className="h4">{translate('NorwegianRewards_WhyAccount2')}</li>
                  <li className="h4">{translate('NorwegianRewards_WhyAccount3')}</li>
                  <li className="h4">{translate('NorwegianRewards_WhyAccount4')}</li>
                </ul>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default NorwegianRewards
